export default __webpack_public_path__ + "static/chess-106fb836e275429bb3078b554c0d2108.webp";